import { render, staticRenderFns } from "./distributionDetail.vue?vue&type=template&id=6fce030c&scoped=true"
import script from "./distributionDetail.vue?vue&type=script&lang=js"
export * from "./distributionDetail.vue?vue&type=script&lang=js"
import style0 from "./distributionDetail.vue?vue&type=style&index=0&id=6fce030c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fce030c",
  null
  
)

export default component.exports